import { useFormikContext } from "formik";
import React from "react";
/**
 * Function to generate a field error message.
 *
 * @param {string} name - The name of the field
 * @param {string} tag - The HTML tag to use for the error message (default is "div")
 * @param {string} className - The CSS class for the error message
 * @return {JSX.Element} The error message component
 */
const FieldErrorMessage = ({ name, tag = "div", className }) => {
  const { errors, submitCount, touched } = useFormikContext();

  if ((submitCount > 0 && errors[name]) || (touched[name] && errors[name])) {
    return React.createElement(
      tag,
      { className: `!mt-[3px] error ${className ? className : ""}` },
      errors[name],
    );
  }
  // return (
  //   <ErrorMessage
  //     name={name}
  //     component={tag}
  //     className={`!mt-[3px] error ${className ? className : ""}`}
  //   />
  // )
};

export default FieldErrorMessage;
